import React, { Component } from 'react';
import ExpHelper from '../../../../Common/Helpers/ExpHelper';
import Carteras from './Carteras';

class Facturacion extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { children } = this.props;
        let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row bottom-separator">
                        <div className="col-xs-12">
                            <h2>{"Facturaci" + acentoLetraOminuscula + "n"}</h2>
                        </div>
                    </div>

                    {children}

                </div>
            </div>
        );
    }
};

export default Facturacion;